<div class="modal-content modal-milvus">
  <div class="modal-header-milvus align-items-center">
      <div class="col-6 header-col">
          <span class="modal-title" id="modal-title-default">{{'TRANSFERIR_CHAT' | translate}}</span>
      </div>
      <div class="col-6 header-col">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
              <i class="mdi mdi-close"></i>
            </button>
      </div>
  </div>

  <div class="modal-body">
      <div clas="row mt-3">
          <div class="col-12 pl-0">
            <label>
                {{ 'TRANSFERIR_PARA' | translate }}
            </label>
          </div>
      </div>
        <div class="row mt-3">
            <div class="col-12">
                <label class="radio-box">
                    <div class="col d-flex justify-content-start">
                        <input type="radio" name="padrao_todos" id="liberado" [(ngModel)]="tipoTransferencia" [value]="1" />
                        <span class="checkmark"></span>
                    </div>
                </label>
                <label style="font-size: 12px; font-weight: normal; margin-right: 10px;"
                    [translate]="'FILA_ATENDIMENTO'"></label>
            </div>
        </div>
        <div class="row mb-4 mt-3">
            <div class="col-12">
                <label class="radio-box">
                    <div class="col d-flex justify-content-start">
                        <input type="radio" name="padrao_todos" id="bloqueado_somente_leitura" [(ngModel)]="tipoTransferencia" [value]="2" />
                        <span class="checkmark"></span>
                    </div>
                </label>
                <label style="font-size: 12px; font-weight: normal;" [translate]="'OPERADOR'"></label>
            </div>
        </div>
        <div class="row mb-4 mt-3" *ngIf="tipoTransferencia === 1">
            <div class="col-12 pl-4">
                <select-padrao [entidade]="'getFilasChat'" [params]="chatData" [model]="fila"  [returnObj]="true" (selectChange)="changeFila($event)"></select-padrao>
            </div>
        </div>
        <div class="row mb-4" *ngIf="tipoTransferencia === 2">
            <div class="col-12 pl-4">
                <select-padrao [entidade]="'getTecnicosTransferencia'" [params]="chatData" [model]="tecnico" [returnObj]="true" (selectChange)="changeTecnico($event)"></select-padrao>
            </div>
        </div>

        <!-- Transferência para Workflow -->
        <ng-container *ngIf="is_fila_workflow">
            <div class="row mt-4">
                <div class="col-12">
                    <label>
                        {{ 'ENCAMINHAR_DIRETO_PARA' | translate }}
                    </label>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-12">
                    <label class="radio-box">
                        <div class="col d-flex justify-content-start">
                            <input type="radio" name="transferir_fila_tipo" id="transferir_fila" [(ngModel)]="tipo_transferencia_fila" [value]="1" />
                            <span class="checkmark"></span>
                        </div>
                    </label>
                    <label style="font-size: 12px; font-weight: normal; margin-right: 10px;"
                        [translate]="'FILA_ATENDIMENTO'"></label>
                </div>
            </div>
            <div class="row mb-4 mt-3">
                <div class="col-12">
                    <label class="radio-box">
                        <div class="col d-flex justify-content-start">
                            <input type="radio" name="transferir_fila_tipo" id="transferir_workflow" [(ngModel)]="tipo_transferencia_fila" [value]="2" />
                            <span class="checkmark"></span>
                        </div>
                    </label>
                    <label style="font-size: 12px; font-weight: normal;">Workflow</label>
                </div>
            </div>
        </ng-container>

        <ng-container>
            <div class="row mt-2">
                <div class="col-12">
                    <label>
                        {{ 'MSGS_TRANSFERIDAS' | translate }}
                    </label>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="custom-control custom-checkbox ml-2">
                        <input type="checkbox" class="custom-control-input" id="checkboxEnviaMsgsSelecionadas" [(ngModel)]="enviaMsgs">
                        <label class="custom-control-label pt-1" for="checkboxEnviaMsgsSelecionadas">{{'SELECIONAR_ENVIAR_MSGS_CONVERSA' | translate}}</label>
                    </div>
                </div>
                <div *ngIf="!enviaMsgs && msgSelecionadas && msgSelecionadas.length" class="col-12">
                    <b class="ml-2">
                        {{'HA_MAIUSCULO' | translate}}
                        <span style="color: #2dce89" class="ml-1 mr-1">{{msgSelecionadas.length + ' ' + ('MENSAGENS_MINUSCULO' | translate)}}</span>
                        {{'HA_X_MENSAGENS_PARA_TRANSFERIR' | translate}}
                    </b>
                </div>
                <div *ngIf="enviaMsgs" class="col-12">
                    <b class="ml-2">
                        {{'HA_MAIUSCULO' | translate}}
                        <span style="color: #2dce89" class="ml-1 mr-1">{{mensagensChat.length + ' ' + ('MENSAGENS_MINUSCULO' | translate)}}</span>
                        {{'HA_X_MENSAGENS_PARA_TRANSFERIR' | translate}}
                    </b>
                </div>
            </div>
        </ng-container>

        <div class="row mt-4">
            <div class="col-12">
                <label>
                    {{ 'OBS_PROXIMO_ATENDENTE' | translate }}
                </label>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-12">
                <textarea class="form-control" rows="9" [(ngModel)]="observacao" style="resize: none;" placeholder="{{'DESCREVA' | translate}}" [disabled]="is_fila_workflow && tipo_transferencia_fila === 2"></textarea>
            </div>
        </div>
    </div>
    <div class="modal-footer modal-footer-milvus">
        <button class="btn badge-pill btn-mv-primary" [disabled]="transferindo" (click)="verificaTransferencia()">
            <span [translate]="'TRANSFERIR'"></span>
        </button>
    </div>
</div>